import TemplateView from '../../../../../../js/TemplateView'
import ICalFeedUserSelector from '../edit/ICalFeedUserSelector'
import ICalFeedLeaveTypesSelector from '../edit/ICalFeedLeaveTypesSelector'
import messageResource from '../../../../../../js/messageResource'
import {bindActionCreators} from 'redux'
import ICalFeedDateRangeSelector from '../edit/ICalFeedDateRangeSelector'
import {DEFAULT_LEAVE_TYPE_SELECTION, DEFAULT_USER_SELECTION} from '../constants'
import {connect} from '../../../../../../js/redux/utils'
import {getDateRangeSelection, getLeaveTypeSelection, getUserSelection, isDateRangeSelectionValid, isIncludesNotApproved} from '../selectors'
import {getActiveUsersArray, getLeaveTypesArray, getTimeZoneGroupsArray, getUserGroupsArrayWithDefault} from '../../../../../../js/entities/selectors'
import {setDateRangeSelection, setFeedLeaveTypeSelection, setIncludeNotApproved, setUserSelection} from '../actions'

class ExportICalLightBoxContent extends TemplateView {
    constructor({
        setUserSelection,
        setFeedLeaveTypeSelection,
        setIncludeNotApproved,
        setDateRangeSelection
    }) {
        super()

        this.actions = {
            setUserSelection,
            setFeedLeaveTypeSelection,
            setIncludeNotApproved,
            setDateRangeSelection
        }

        this.state = {
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            leaveTypes: [],
            userSelection: DEFAULT_USER_SELECTION,
            leaveTypeSelection: DEFAULT_LEAVE_TYPE_SELECTION,
            includeNotApproved: false,
            dateRangeSelection: null,
            dateRangeSelectionValid: false,
        }

        this.onAnyStatePropertyChanged(['users', 'userGroups', 'timeZoneGroups'], state => {
            this.userSelector.setState({
                users: state.users,
                userGroups: state.userGroups,
                timeZoneGroups: state.timeZoneGroups,
            })
        })

        this.onStatePropertyDeeplyChanged('userSelection', userSelection => this.userSelector.setState({userSelection}))

        this.onAnyStatePropertyDeeplyChanged(['leaveTypes', 'leaveTypeSelection'], () => {
            this.leaveTypeSelector.setState({
                leaveTypes: this.state.leaveTypes,
                leaveTypeSelection: this.state.leaveTypeSelection,
            })
        })

        this.onStatePropertyChanged('includeNotApproved', includeNotApproved => this.leaveTypeSelector.setState({includeNotApproved}))
        this.onAnyStatePropertyDeeplyChanged(['dateRangeSelection', 'dateRangeSelectionValid'], state =>
            this.dateRangeSelector.setState({
                selection: state.dateRangeSelection,
                selectionValid: state.dateRangeSelectionValid
            }))
    }

    templateHtml() {
        return `<div class='iCalLightBoxContent exportFeedLightBoxContent'>
                    <div class='mainContainer'>
                        <div class='userSelectorWrapper'/>
                        <div class='leaveTypesSelectorWrapper'/>
                        <div class='dateRangeSelectorWrapper'/>
                    </div>
                </div>`
    }

    afterRender() {
        this.userSelector = new ICalFeedUserSelector({
            title: messageResource.getMessage('icalendar.page.lightbox.userselection.description'),
            onSelectionChanged: this.actions.setUserSelection
        }).init(this.find('.userSelectorWrapper'))

        this.leaveTypeSelector = new ICalFeedLeaveTypesSelector({
            selectorId: 'exportICalLeaveTypeSelector',
            onLeaveTypeSelectionChanged: this.actions.setFeedLeaveTypeSelection,
            onCheckboxClick: this.actions.setIncludeNotApproved,
        }).init(this.find('.leaveTypesSelectorWrapper'))

        this.dateRangeSelector = new ICalFeedDateRangeSelector({
            onSelectionChanged: this.actions.setDateRangeSelection,
        }).init(this.find('.dateRangeSelectorWrapper'))
    }
}

export default connect(
    state => ({
        users: getActiveUsersArray(state),
        userGroups: getUserGroupsArrayWithDefault(state),
        leaveTypes: getLeaveTypesArray(state),
        timeZoneGroups: getTimeZoneGroupsArray(state),
        userSelection: getUserSelection(state),
        leaveTypeSelection: getLeaveTypeSelection(state),
        includeNotApproved: isIncludesNotApproved(state),
        dateRangeSelection: getDateRangeSelection(state),
        dateRangeSelectionValid: isDateRangeSelectionValid(state),
    }),
    dispatch => bindActionCreators({
        setUserSelection,
        setFeedLeaveTypeSelection,
        setIncludeNotApproved,
        setDateRangeSelection
    }, dispatch)
)(ExportICalLightBoxContent)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/export/ExportICalLightBoxContent.js